import React from "react";
import Webcam from "react-webcam";
import {} from './WebCam.css';
import config from '../config';
class WebcamCapture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenshot: null,
      blob: null,
      user: null,
      faceReco: false,
      error: false,
    };
  }
  componentDidMount(){
    //  parse query string
    let _ss = window.location.search;
    let _redirectURL = "";
    let _qs=null;
    if(typeof _ss !== 'undefined' && _ss.trim().length>0){
        //  check if the query string contains & character
        if(_ss.indexOf("&") >= 0){
            // then split  with & too
            _qs=  _ss.split("?")[1].split("&");
        }
        else{
            _qs = [];
            _qs.push(_ss.split("?")[1]);
        }
        
        let _query = [];        
        _qs.forEach(function(item, index, array) {
            //console.log(item, index);
            let _k = item.split("=")[0]
            let _v = item.split("=")[1]
            let _item = {}
            _item[_k] = _v
            _query.push(_item)
        });
        // collect redirect url
        
        _query.forEach(function(item, index, array) {
            //console.log(item, index);
            for(var prop in item) {
                if(item.hasOwnProperty(prop))                    
                    if(prop === 'redirectURL') {                        
                        _redirectURL = decodeURIComponent(item[prop]);
                    }
            }
        });
    }
    // let _redirectURL= decodeURIComponent(window.location.search.split("=")[1]);
    //console.log(_redirectURL);
    let redirectURL = null;
    if (typeof _redirectURL !== 'undefined') { redirectURL = _redirectURL } else{redirectURL=null}
    this.setState({
        searchString: _ss,           
        redirectURL: redirectURL,
    });
  }   

  handleDone = event =>{
        //console.log(event);
        if(this.state.screenshot){
          //console.log('yes');       
        // Split the base64 string in data and contentType
        let block = this.state.screenshot.split(";");
        // Get the content type of the image
        let contentType = block[0].split(":")[1];// In this case "image/gif"
        // get the real base64 content of the file
        let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        let blob = this.b64toBlob(realData, contentType);    
        // Create a FormData and append the file with "image" as parameter name
        let data = new FormData();
        data.append("media", blob, new Date().getTime()+ "face.jpg");
        
        // let faceReco = false;
        // let user = null;
        let _API_URI = config.API_BASE_URL + config.API_FACE;
        // let _API_URI = 'http://10.26.24.36:4001/MLA_facerec_login_verification'
        let _method = 'POST';
        //let _headers = {
            //"Content-Type": "application/json",            
         // }
        //  url: _API_URI,
        let redirectURL = this.state.redirectURL;
        fetch(_API_URI,{            
            method: _method,
            body: data,
            mode: "cors", // no-cors, cors, *same-origin
            // headers: _headers,
        })
        .then(response => {          
          return response.json();
        })
        .then(obj => {
           if(obj.success){
            this.setState({
              user: obj.data.user,
              faceReco: true,
            });
            //
            this.props.history.push({
              pathname: '/otp',
              search: `?token=${obj.data.token}&redirectURL=${redirectURL}&user=${obj.data.user}`,
              state: { token: obj.data.token }
            })
           }
           else{
            this.setState({
              user: null,
              faceReco: false,
              error: true,
              message: obj.message,
            });
           }
           
         })
        .catch(error => {
          // catch error
          console.error(error);
          this.setState({
            user: null,
            faceReco: false,
            error: true,
              message: error.message,
          });
        });
    //call api
    }else{
      //console.log('no');
    }
  }

  handleClick = () => {
    const screenshot = this.webcam.getScreenshot();
    this.setState({ screenshot });
    // convert this to a image file

  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

  let blob = new Blob(byteArrays, {type: contentType});
  return blob;
}
  render() {
    const width ='100%';
    const videoConstraints = {
      width: 640,
      height: 480,
      facingMode: "user"
    };
    
    const { error, message } = this.state;   
        return (
          <div className="container">
            <div className="card card-face mx-auto mt-24 ">
              <div className="login-header text-center">FaceID</div>
                <div className="card-body">
                {error &&
                <div className="alert alert-danger">
                    <strong>Error! </strong>{ message }
                </div>
                }
                  <div id="container" className="faceContainer">            
                    <Webcam
                      audio={false}
                      ref={node => this.webcam = node}                            
                      screenshotFormat="image/jpeg"              
                      videoConstraints={videoConstraints}
                      screenshotQuality={0.90}
                      width={width}
                    />            
                    <div>              
                      <div className='screenshots'>
                        <div className='controls'>
                          <button type="button" className="btn btn-primary margin-5" onClick={this.handleClick}>Capture</button>
                          <button type="button" className="btn btn-success margin-5" onClick={this.handleDone}>Submit</button>
                        </div>
                        {this.state.screenshot ? <img alt="screenshot" src={this.state.screenshot} /> : null}
                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <a className=" small mt-3" href="/pnc/auth/">Login using password</a>
                  </div>
                  <div className="text-center">  
                    <a className=" small mt-3" href="/pnc/auth/register">Register for an Account</a>
                  </div>
                  <div className="text-center">
                    <a className=" small" href="/pnc/auth/forgotpassword">Forgot Password?</a>                  
                  </div>
                </div>
              </div>
            </div>
        );
      }
  }

  export default WebcamCapture;


// WEBPACK FOOTER //
// ./src/components/WebCam.js